import PartnerDemoLogo from './PartnerDemoLogo';

export default PartnerDemoLogo;
